<template>
  <b-container>
    <b-row align-h="end" class="mb-1">
      <b-col md="2">
        <b-button
          class="float-right"
          :to="{ name: 'campaigns-create' }"
          variant="flat-primary"
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        >
          <feather-icon icon="PlusIcon" />
          تبلیغ جدید
        </b-button>
      </b-col>
    </b-row>
    <b-row
      ><b-table
        :items="$store.getters['campaigns/getUserCampaigns']"
        :fields="fields"
        striped
        hover
      >
        <template #cell(show_details)="row">
          <b-button
            v-model="row.detailsShowing"
            variant="flat-primary"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            @click="row.toggleDetails"
          >
            {{ !row.detailsShowing ? 'جزییات' : 'خلاصه' }}</b-button
          >
        </template>

        <!-- <template #cell(show_details)="row">
          <b-form-checkbox
            v-model="row.detailsShowing"
            plain
            class="vs-checkbox-con"
            @change="row.toggleDetails"
          >
            <span class="vs-checkbox">
              <span class="vs-checkbox--check">
                <i class="vs-icon feather icon-check" />
              </span>
            </span>
            <span class="vs-label">{{
              row.detailsShowing ? 'Hide' : 'Show'
            }}</span>
          </b-form-checkbox>
        </template> -->
        <template #row-details="row">
          <b-card>
            <b-row>
              <b-col md="3">
                <span>Detais</span>
              </b-col>
            </b-row>

            <b-col md="6" offset-md="3">
              <b-button
                variant="outline-primary"
                block
                @click="row.toggleDetails"
                >بستن</b-button
              >
            </b-col>
          </b-card>
        </template>
      </b-table>
    </b-row>
  </b-container>
</template>

<script>
import { BRow, BCol, BButton, BContainer, BTable, BCard } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BButton,
    BContainer,
    BTable,
    BCard,
  },
  data() {
    return {
      fields: [
        { key: 'descreption', label: 'کمپین' },
        { key: 'viewCount', label: 'تعداد نمایش' },
        { key: 'completeViewCount', label: 'تعداد نمایش کامل' },
        { key: 'clickCount', label: 'تعداد کلیک' },
        { key: 'show_details', label: '#' },
      ],
      items: [
        {
          descreption: 'سلام',
          viewCount: 5,
          completeViewCount: 3,
          clickCount: 1,
        },
        {
          descreption: 'اوی',
          viewCount: 10,
          completeViewCount: 5,
          clickCount: 3,
        },
        {
          descreption: 'هی',
          viewCount: 8,
          completeViewCount: 6,
          clickCount: 4,
        },
      ],
    }
  },
  created() {
    this.$store.dispatch('campaigns/getUserCampaigns').then(() => {
      // console.log(
      //   `getter is: ${JSON.stringify(
      //     this.$store.getters['campaigns/getUserCampaigns'],
      //   )}`,
      // )
    })

    // console.log(`store is: ${JSON.stringify(this.$store.getters)}`)
  },
}
</script>
<style scoped>
[dir] .btn-flat-primary:active,
[dir] .btn-flat-primary.active,
[dir] .btn-flat-primary:focus {
  background-color: transparent;
}
</style>
